var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.modelStyle.width,
        visible: _vm.visible,
        bodyStyle: _vm.bodyStyle,
        switchFullscreen: _vm.switchFullscreen
      },
      on: {
        cancel: _vm.handleCancel,
        setInnerFullscreen: _vm.setInnerFullscreen
      }
    },
    [
      _c(
        "template",
        { slot: "footer" },
        [
          _c("a-button", { key: "back", on: { click: _vm.handleCancel } }, [
            _vm._v(_vm._s(_vm.language["common.closeButton"]))
          ])
        ],
        1
      ),
      _c(
        "a-card",
        { staticClass: "daily-article", attrs: { loading: _vm.loading } },
        [
          _c("a-card-meta", {
            attrs: {
              title: _vm.record.title,
              description:
                _vm.language["common.creator"] +
                "：" +
                (_vm.record.editor
                  ? _vm.record.editor
                  : _vm.language["common.not"]) +
                " | " +
                _vm.language["common.createTime"] +
                "：" +
                (_vm.record.createTime
                  ? _vm.record.createTime
                  : _vm.language["common.not"])
            }
          }),
          _c("a-divider"),
          _c("span", {
            staticClass: "article-content",
            domProps: { innerHTML: _vm._s(_vm.record.contentHtml) }
          }),
          _vm.record.imageList && _vm.record.imageList.length > 0
            ? _c(
                "div",
                [
                  _c("a-divider"),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        gap: "10px",
                        padding: "10px",
                        "flex-wrap": "wrap"
                      }
                    },
                    _vm._l(_vm.record.imageList, function(file) {
                      return _c(
                        "div",
                        {
                          key: file.imageId,
                          staticStyle: {
                            display: "flex",
                            gap: "0px",
                            padding: "10px",
                            "margin-right": "10px",
                            "background-color": "rgb(107,166,215,0.16)",
                            width: "18%",
                            cursor: "pointer"
                          },
                          attrs: { value: file.src },
                          on: {
                            click: function($event) {
                              return _vm.openFile(file.src)
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticStyle: { width: "48px" },
                            attrs: {
                              src: require("@/assets/file.svg"),
                              alt: "logo"
                            }
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                                "justify-content": "center",
                                "font-weight": "900",
                                "font-size": "15px",
                                width: "calc(100% - 48px)"
                              },
                              attrs: { title: file.title }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    overflow: "hidden",
                                    "text-overflow": "ellipsis",
                                    "-webkit-line-clamp": "2",
                                    "-webkit-box-orient": "vertical",
                                    display: "-webkit-box"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(file.title) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }